import Schema from 'AppReact/schema';

export default {
  searchTerms: Schema('string', 'array', { defaultValue: [] }),
  value: Schema('string', 'primitive', { defaultValue: '' }),
  label: Schema('string', 'primitive-nullable', { defaultValue: null }),
}